import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import analyticsService from 'services/analyticsService';

export const useDashboardsQuery = (options) => {
  return useQuery(
    analyticsService.getDashboardKey(),
    () => analyticsService.dashboards.list(),
    options,
  );
};

export const useCopyDashboardsMutation = ({ ...options }) => {
  const queryClient = useQueryClient();

  return useMutation(({ data }) => analyticsService.dashboards.copyTo(data), {
    onError: (error) => options.onError && options.onError(error),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: analyticsService.getDashboardKey(),
      });
      options.onSuccess && options.onSuccess(data);
    },
  });
};
